export default __webpack_public_path__ + "static/media/failureDesktop_bg.6c02b6f7.png";